import React, { useEffect, useState } from 'react'
import { useRequest } from 'ahooks'
import moment from 'moment'
import classnames from 'classnames'

import ToKissFooter from '@kiss/components/ToKissFooter'

import { getKissNumber } from '@kiss/utils/math'
import { getLocationVars } from '@/utils/utils'
import { createBookSharePageUrl } from '@kiss/utils/url'

import headerLogo from '@kiss/assets/logos/icon_kiss.png'
import defaultAvator from './assets/default_avatar.png'
import femaleIcon from './assets/icon_famale.png'
import maleIcon from './assets/icon_male.png'
import './App.scss'

import { getUserData } from '@kiss/services/shareBookPage'
import { clickGet } from '../../utils/reportInfo/reportedMethods'

interface IBook {
  book_title: string
  book_pic: string
  book_id: string
  read_count: number
  chapter_count: number
}
const urlQueryParams = getLocationVars()

const renderGenderTag = (sex: 0 | 1 | 2) => {
  if (sex === 0) return null
  return (
    <div className='author-tag'>
      {sex === 1 ? <img src={maleIcon} /> : <img src={femaleIcon} />}
      <div>{sex === 1 ? 'male' : 'female'}</div>
    </div>
  )
}

// YYYY-MM-DD
const renderBirthdayTag = (birthdayStr: string) => {
  if (!birthdayStr) return null
  if (!moment(birthdayStr).isValid()) return console.log('生日格式有问题')
  const age = moment().diff(moment(birthdayStr), 'years')
  return <div className='author-tag'>{`${age} years old`}</div>
}

const App: React.FC = () => {
  const { uid = '' } = getLocationVars()
  const [active, setActive] = useState<{ title: string; data: any[] }>({
    title: 'Noval',
    data: []
  })
  const { data, error, loading } = useRequest(() => getUserData({ uid }), {
    onSuccess: (res) => {
      if (res.code === 0) {
        tabs.some((item) => {
          if (item.data.length) {
            setActive(item)
            return true
          }
          return false
        })
      }
    }
  })

  const authorInfo = data?.data?.userInfo

  const tabs = [
    {
      title: 'Noval',
      data: data?.data?.books || []
    },
    {
      title: 'Comic',
      data: data?.data?.comic_list || []
    },
    {
      title: 'Audio',
      data: data?.data?.audio_list || []
    }
  ]

  useEffect(() => {
    document.title = authorInfo?.uname || 'Author'
  }, [authorInfo?.uname])

  if (!uid) return <>Error: Required parameter uid missing</>
  if (loading) return null
  if (!authorInfo || !authorInfo.id) return <>Error: No userinfo.</>
  if (error) return <>An error has occurred, please try again</>
  if (data?.code !== 0) return <>{JSON.stringify(data?.msg)}</>

  const authorData = [
    { title: 'Followers', number: authorInfo.fans_num },
    { title: 'Visitors', number: authorInfo.visitor_num },
    { title: 'Following', number: authorInfo.follow_num }
  ]

  // 跳转到书籍详情页
  const pushToBookPage = (bookData: any) => {
    const bookType = active.title
    const classify = {
      Noval: { url: 'shareBookPage', type: '1' },
      Comic: { url: 'shareComicPage', type: '3' },
      Audio: { url: 'shareAudioPage', type: '2' }
    }

    const { randomId = '', type = '', pushType = '' } = getLocationVars()

    clickGet({
      parm1: 1,
      parm5: 'h5_author_share_click',
      parm7: bookData.book_id,
      parm9: location.href,
      // @ts-ignore
      parm10: classify[bookType].type
    })

    window.open(
      `../${
        // @ts-ignore
        classify[bookType].url
      }?${createBookSharePageUrl({
        bookId: bookData.book_id,
        type: 1001,
        pushType: 1,
        randomId
      })}`
    )
  }
  return (
    <div className='page-ctr'>
      <header>
        <img src={headerLogo} alt='' />
      </header>
      <div className='author-desc-img-ctr'></div>
      <div className='author-content'>
        <div className='avatar-ctr'>
          <div className='avatar-box'>
            <img src={authorInfo.pic || defaultAvator} id='avator' alt='' />
          </div>

          {authorInfo.is_author && (
            <div className='author-badge'>
              <span>Author</span>
            </div>
          )}
        </div>
        <div className='author-name'>{authorInfo.uname}</div>
        {(authorInfo.usex_set === 1 || authorInfo.birthday_set === 1) && (
          <div className='author-tags'>
            {authorInfo.usex_set === 1 && renderGenderTag(authorInfo.usex)}
            {authorInfo.birthday_set === 1 &&
              renderBirthdayTag(authorInfo.birthday)}
          </div>
        )}
        {authorInfo.about_me && (
          <div className='author-description'>{authorInfo.about_me}</div>
        )}
      </div>
      <div className='author-data-ctr'>
        {authorData.map((item) => (
          <div className='author-data-box' key={item.title}>
            <div className='data-number'>{getKissNumber(item.number)}</div>
            <div className='data-title'>{item.title}</div>
          </div>
        ))}
      </div>
      <div
        style={{ width: '100vw', height: '.18rem', background: '#f5f5f5' }}
      ></div>

      {active?.data?.length > 0 ? (
        <div className='book-list-ctr'>
          <div className='book-list-head'>
            {tabs.map((item) => {
              return item.data.length ? (
                <div
                  className={`book-list-title ${item.title} ${
                    active.title === item.title ? 'active' : ''
                  }`}
                  key={item.title}
                  onClick={() => {
                    setActive(item)
                  }}
                >
                  {item.title} <span>({item.data.length})</span>
                </div>
              ) : null
            })}
          </div>
          <div
            className={`book-list ${
              active.title === 'Audio' ? 'audio-list' : ''
            }`}
          >
            {active.data.map((book: IBook, idx: number) => (
              <div
                key={book.book_id}
                className={classnames({
                  'book-item': true,
                  'book-item-hot': idx < 3
                })}
                onClick={() => pushToBookPage(book)}
              >
                <div className='book-cover-box'>
                  <img src={book?.book_pic} alt={book.book_title} />
                  <div className='book-data-ctr'>
                    <div className='chapter-number'>{book.chapter_count}</div>
                    <div className='read-number'>
                      {getKissNumber(book.read_count)}
                    </div>
                  </div>
                </div>
                <div className='book-title'>{book.book_title}</div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className='no-book-desc-ctr'>Currently no book.</div>
      )}
      <ToKissFooter
        kissLinkData={urlQueryParams}
        customParamsDic={{ parm1: 'uid' }}
        reportParams={{
          parm1: 2,
          parm5: 'h5_author_share_click'
        }}
      ></ToKissFooter>
    </div>
  )
}

export default App
